import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { downloadCsvFile } from "../general";

/**
 * Rows that failed validation during a direct data import (and were skipped so
 * the rest could register). The BE persists them per import for 7 days;
 * these hooks power the "Download failed rows (CSV)" action on the import
 * progress tracker.
 */

export const useFailedImportRowsCount = (importId, { enabled = true } = {}) => {
  return useQuery(
    ["failedImportRowsCount", importId],
    async () => {
      const { data } = await axios.get(
        `/api/content/getFailedImportRowsCount/${importId}`
      );
      return data.count || 0;
    },
    {
      enabled: enabled && !!importId,
    }
  );
};

export const useDownloadFailedImportRowsCsv = () => {
  return useMutation(async (importId) => {
    const { data } = await axios.get(
      `/api/content/downloadFailedImportRowsCsv/${importId}`,
      { responseType: "text" }
    );
    downloadCsvFile({
      data,
      fileName: `failed_import_rows_${importId}`,
    });
  });
};
